'use client';

import StyledComponentsRegistry from 'app/libs/styled-component';
import React from 'react';
import * as styled from '@wconcept/wconcept-ui-renewal/styled-components';
import '@wconcept/wconcept-ui-renewal/public/assets/fonts/fonts.css';
import { style } from '@wconcept/wconcept-ui-renewal/src/styles';
import NavSkip from '@wconcept/wconcept-ui-renewal/components/molecules/NavSkip';

const { GlobalStyles, theme } = style;
const { ThemeProvider } = styled;

function StyledProvider({ children }: React.PropsWithChildren) {
  return (
    <StyledComponentsRegistry>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <NavSkip />
        {children}
      </ThemeProvider>
    </StyledComponentsRegistry>
  );
}

export default StyledProvider;
